/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Ats_SectionsInputs */

const en_onboarding_ats_sections = /** @type {(inputs: Onboarding_Ats_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sections`)
};

const de_onboarding_ats_sections = /** @type {(inputs: Onboarding_Ats_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abschnitte`)
};

const fr_onboarding_ats_sections = /** @type {(inputs: Onboarding_Ats_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sections`)
};

const es_onboarding_ats_sections = /** @type {(inputs: Onboarding_Ats_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secciones`)
};

const it_onboarding_ats_sections = /** @type {(inputs: Onboarding_Ats_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sezioni`)
};

const nl_onboarding_ats_sections = /** @type {(inputs: Onboarding_Ats_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secties`)
};

const pl_onboarding_ats_sections = /** @type {(inputs: Onboarding_Ats_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sekcje`)
};

const fi_onboarding_ats_sections = /** @type {(inputs: Onboarding_Ats_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osiot`)
};

const da_onboarding_ats_sections = /** @type {(inputs: Onboarding_Ats_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sektioner`)
};

const sv_onboarding_ats_sections = /** @type {(inputs: Onboarding_Ats_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sektioner`)
};

/**
* | output |
* | --- |
* | "Sections" |
*
* @param {Onboarding_Ats_SectionsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_ats_sections = /** @type {((inputs?: Onboarding_Ats_SectionsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Ats_SectionsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_ats_sections(inputs)
	if (locale === "fr") return fr_onboarding_ats_sections(inputs)
	if (locale === "es") return es_onboarding_ats_sections(inputs)
	if (locale === "it") return it_onboarding_ats_sections(inputs)
	if (locale === "nl") return nl_onboarding_ats_sections(inputs)
	if (locale === "pl") return pl_onboarding_ats_sections(inputs)
	if (locale === "fi") return fi_onboarding_ats_sections(inputs)
	if (locale === "da") return da_onboarding_ats_sections(inputs)
	if (locale === "sv") return sv_onboarding_ats_sections(inputs)
	return en_onboarding_ats_sections(inputs)
});